/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganizationInfo } from './ZendeskOauthClient';

export interface ZendeskUserInfo {
    name: string;
    email: string;
    id: number;
}

export interface ZendeskAuthResponse {
    success: boolean;
    accessToken: string;
}

export interface ZendeskAuthInfo {
    accessToken: string;
    refreshToken?: string;
}

export interface ZendeskAuthState {
    isLoggedIn: boolean;
    authInfo: ZendeskAuthInfo;
    userInfo: ZendeskUserInfo;
    organizations: OrganizationInfo[];
}

function resetState(state: ZendeskAuthState): void {
  state.isLoggedIn = false;
  state.authInfo = {
    accessToken: '',
    refreshToken: undefined,
  };
  state.userInfo = {
    name: '',
    email: '',
    id: -1,
  };
  state.organizations = [];
}

export const initialState: ZendeskAuthState = {
  isLoggedIn: false,
  authInfo: {
    accessToken: '',
    refreshToken: undefined,
  },
  userInfo: {
    name: '',
    email: '',
    id: -1,
  },
  organizations: [],
};

export const zendeskSlice = createSlice({
  name: 'zendeskAuth',
  initialState,
  reducers: {
    setLoggedIn: (state, action: PayloadAction<ZendeskAuthResponse>) => {
      if (action.payload.success) {
        state.isLoggedIn = true;
        state.authInfo.accessToken = action.payload.accessToken;
      }
    },
    setLoggedOut: (state) => {
      resetState(state);
    },
    setUserInfo: (state, action: PayloadAction<ZendeskUserInfo>) => {
      if (state.isLoggedIn) {
        state.userInfo = action.payload;
      }
    },
    setUserOrganizations: (state, action: PayloadAction<OrganizationInfo[]>) => {
      if (state.isLoggedIn) {
        state.organizations = action.payload;
      }
    },
  },
});

export const {
  setLoggedIn, setLoggedOut, setUserInfo, setUserOrganizations,
} = zendeskSlice.actions;

export default zendeskSlice.reducer;
